import styled from 'styled-components';

export const FooterLayout = styled.header`
  background: #1b1c29;
  width: 100%;
  padding: 40px 0 0 0;
`;

export const FooterContainer = styled.div`
  width: 100%;
`;

export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.3fr;
  grid-column-gap: 2.5em;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 48px;
  }

  @media (max-width: 368px) {
    grid-template-columns: 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 3rem;
  }
`;

export const FooterGridItem = styled.div`
  .logo {
    width: 200px;
  }

  p {
    font-family: 'Lato', sans-serif;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: 0.3px;
    text-align: left;
    color: ${({ theme }) => theme.colors['display-500']};
    margin-bottom: 20px;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }

  ul {
    list-style: none;
    line-height: 1.67;

    li {
      padding: 8px 0;
      color: ${({ theme }) => theme.colors.white};
      font-size: 14px;
      font-stretch: normal;
      letter-spacing: 0.3px;

      @media (max-width: 768px) {
        font-size: 0.9rem;
      }

      a {
        font-family: 'Lato', sans-serif;
        font-weight: 400;
        text-decoration: none;
        color: ${({ theme }) => theme.colors.white};
        font-size: 14px;
        font-stretch: normal;
        letter-spacing: 0.3px;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
`;

export const MainFooterWrapper = styled.section`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: flex-start;

  max-width: 1328px;

  @media (max-width: 1440px) {
    width: 90%;
  }
`;

export const Button = styled.button`
  font-family: 'Lato', sans-serif !important;
  background: none;
  border: none;
  bottom: 0;
  border-radius: 32px;
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-stretch: normal;
  letter-spacing: 0.3px;
  font-weight: 400;
  left: 0;
  padding: 0;
  position: relative;
  text-align: left;
  text-decoration: none;

  &:hover {
    opacity: 0.7;
  }
`;
